<div class="flex flex-col ml-60">
  <div class="flex flex-row justify-end items-center search-wrapper pt-16 pb-16">
    <app-search-filter (keyup)="searchBlueprint($event)" [placeholder]="'SEARCH.SEARCH'"></app-search-filter>
  </div>
  <div class="flex flex-row flex-wrap">
    <ng-container *ngIf="initialLoader">
      <ng-container *ngFor="let item of [1,2,3,4]">
            <div class="card-tile p-16 m-16 cursor-pointer">
              <div class="flex flex-row justify-between">
                <ngx-skeleton-loader class="pr-30" count="1" appearance="line"></ngx-skeleton-loader>
              </div>
              <ngx-skeleton-loader class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
              <div class="flex flex-col pt-12">
                <ngx-skeleton-loader class="loader-line pr-30" count="2" appearance="line"></ngx-skeleton-loader>
              </div>
            </div>
          </ng-container>
    </ng-container>
    <div class="card-tile p-16 m-16 cursor-pointer" *ngFor="let service of serviceDefinitionList" (click)="openInstance(service)">
        <div class="flex flex-row justify-between">
          <div class="mat-headline-5 solution-names">{{service?.name}}</div>
        </div>
        <ng-container *ngIf="!service?.solutionName; else displaySolution">
          <ngx-skeleton-loader class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
        </ng-container>
        <ng-template #displaySolution>
          <div class="flex flex-row mb-10">
            <div class="tag-line">{{service?.solutionName}}</div>
          </div>
        </ng-template>
        <div class="flex flex-col pt-12 neutral-color">
          <!-- <ng-container *ngIf="!dataLoaded else region">
            <ngx-skeleton-loader class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
          </ng-container>
          <ng-template #region>
            <div class="flex flex-row pr-8 pb-10">
              <div class="flex flex-row mt-4 mr-8">
                <mat-icon svgIcon="place" class="icon-sm"></mat-icon>
              </div>
              {{tenant ? (tenant[0]?.regionPair || tenant[0]?.temenosRegion) : '-'}}
            </div>
          </ng-template> -->
          <ng-container *ngIf="!dataLoaded; else displayRelease">
            <ngx-skeleton-loader class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
          </ng-container>
          <ng-template #displayRelease>
            <div class="flex flex-row pb-10">
              <mat-icon svgIcon="token" class="icon-md mr-8"></mat-icon>
              {{'TENANT_LAYOUT.SERVICE_DEFINITION.RELEASE_VERSION' | transloco}}
              <ng-container *ngIf="service?.version; else notApplicable">
                {{service?.version}}
                <div *ngIf="service?.isAMR" class="flex flex-row justify-center items-center vertical-dash ml-12 mt-6 pl-10">
                  {{('TENANT_LAYOUT.SERVICE_DEFINITION.AMR' | transloco)}}
                </div>
              </ng-container>
              <ng-template #notApplicable>
                {{'INSTANCE_STATUS.NA' | transloco}}
              </ng-template>
            </div>
          </ng-template>              
        </div>
    </div>
    <div *ngIf="serviceDefinitionList?.length === 0" class="no-data flex justify-center w-100-percent mr-32 flex-col empty-data items-center empty-panel">
      <img src="/assets/images/no-data.png" alt="No data found" class="w-106" /> <div class="mt-6">{{ 'DISASTER_RECOVERY.NO_DATA_FOUND' | transloco }}</div>
    </div>
  </div>
</div>
<div *ngIf="blueprint?.length > 10" class="top-panel ml-72 mr-72 mt-10 mb-10 p-20">
  <app-paginator [length]="blueprint?.length" [pageSizeOptions]="[10, 15, 20]"
    [pageSize]="paginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="pageChanged($event)"></app-paginator>
</div>